import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
} from '@angular/core';
import { IInfoLabels } from 'modules/video-conference/interfaces/infolabels.interface';
import { IContact } from 'shared/interfaces/contact.interface';

@Component({
	selector: 'vc-userinfo',
	templateUrl: './vc-userinfo.component.html',
	styleUrls: ['./vc-userinfo.component.scss'],
})
export class VCUserInfo implements OnChanges {
	incompleteData = false;
	labels: IInfoLabels = <IInfoLabels>{};

	@Output('close') emClick = new EventEmitter<MouseEvent>();

	@Input() contactData: IContact;

	ngOnChanges() {
		if (this.contactData) {
			const contactDataValues = Object.values(this.contactData);

			this.incompleteData = contactDataValues.some(
				(value) => !value || value == ''
			);
		}
	}
}
